// 百家云直播间
const liveBJY = () => import('@/pages/liveBJY/liveBJY.vue');
export default [
  {
    path: '/liveBJY',
    name: 'liveBJY',
    component: liveBJY,
    meta: {
      title: '百家云直播',
      requireAuth: true,
    },
  },
];
